<template>
    <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.8 3C3.81 3 3.009 3.81 3.009 4.8L3 21L6.6 17.4H19.2C20.19 17.4 21 16.59 21 15.6V4.8C21 3.81 20.19 3 19.2 3H4.8ZM16.86 12H7.13998V13.62H16.86V12ZM7.13998 9.56999H16.86V11.19H7.13998V9.56999ZM16.86 7.14001H7.13998V8.76001H16.86V7.14001Z"
        />
    </svg>
</template>
